// Recado de licença Empsis inválida para a tela de login.
//
// O backend responde 403 ERR_LICENSE_INVALID (com o motivo da Empsis em
// `details`, ex.: "Licença Vencida!") no login e em qualquer requisição de uma
// empresa bloqueada. Quem derruba a sessão grava o motivo aqui; a tela de login
// lê e mostra um aviso fixo. Fica fora de SESSION_KEYS pelo mesmo motivo do
// `sessionExpired`: a limpeza da sessão não pode apagar o recado.

export const LICENSE_ERROR_CODE = "ERR_LICENSE_INVALID";

const STORAGE_KEY = "licenseBlocked";
const NOTICE_EVENT = "license-notice";

export const isLicenseError = (err) =>
	err?.response?.data?.error === LICENSE_ERROR_CODE;

export const licenseReasonFrom = (err) => err?.response?.data?.details || "";

export const setLicenseNotice = (reason) => {
	try {
		localStorage.setItem(STORAGE_KEY, reason || "");
	} catch (e) {
		// localStorage indisponível: o aviso só não aparece
	}
	window.dispatchEvent(new Event(NOTICE_EVENT));
};

// Lê e apaga o recado. null = nenhum recado; "" = bloqueado sem motivo detalhado.
export const takeLicenseNotice = () => {
	try {
		const value = localStorage.getItem(STORAGE_KEY);
		if (value === null) return null;
		localStorage.removeItem(STORAGE_KEY);
		return value;
	} catch (e) {
		return null;
	}
};

export const onLicenseNotice = (handler) => {
	window.addEventListener(NOTICE_EVENT, handler);
	return () => window.removeEventListener(NOTICE_EVENT, handler);
};
